import { useContext } from 'react';
import useSWR from 'swr';
import { UseSWRMutationResult } from '../../common/types/swrTypes';
import { getSilentFromApi } from '../../common/utils/apiHelper';
import { ConfigContext } from '../configuration/ConfigContext';
import { usePropertyAssociationContext } from '../propertyAssociation/PropertyAssociationContext';
import { GetApiStatusResponse } from './models/GetApiStatusResponse';

type UseAlertMessagesResult = UseSWRMutationResult<GetApiStatusResponse, 'response'>;

export const useAlertMessages = (): UseAlertMessagesResult => {
    const { apiBaseUrl } = useContext(ConfigContext);
    const { currentPropertyAssociationId } = usePropertyAssociationContext();

    const url = currentPropertyAssociationId ? `${apiBaseUrl}/propertyassociations/${currentPropertyAssociationId}/statusmessages` : null;

    const { data, error, isLoading, mutate } = useSWR<GetApiStatusResponse>(url);

    return {
        response: data,
        isLoading,
        error,
        refetch: () => mutate(),
    };
};

export const getStatuses = (apiBaseUrl: string, propertyAssociationId: string, onSuccess: (data: GetApiStatusResponse) => void, onFail: () => void): void => {
    getSilentFromApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/statusmessages`, onSuccess, onFail);
};
